import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

import { SnackbarData } from '../snackbar.service';

@Component({
  selector: 'lib-info-snackbar',
  templateUrl: './info-snackbar.component.html',
  styleUrls: ['./info-snackbar.component.scss', '../snackbar.scss'],
})
export class InfoSnackbarComponent implements OnInit {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData,
    private snackBarRef: MatSnackBarRef<InfoSnackbarComponent>
  ) {}

  ngOnInit(): void {}

  close() {
    Inject;
    this.snackBarRef.dismiss();
  }
}
